import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'formatDescription'
})
export class FormatDescriptionPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | undefined): SafeHtml {
    if (!value) return '';

    const [beforePipe, afterPipe] = value.split('|');

    const paragraphs = beforePipe
      .split(';')
      .filter(line => line.trim() !== '')
      .map(line => `<p class="custom-paragraph">${line.trim()}</p>`)
      .join('');

    let finalHtml = paragraphs;

    if (afterPipe?.trim()) {
      finalHtml += `<h3 class="custom-heading">¿Estás listo para empezar a disfrutar?</h3>`;
      finalHtml += `<p class="custom-paragraph">${afterPipe.trim()}</p>`;
    }

    return this.sanitizer.bypassSecurityTrustHtml(finalHtml);
  }

}
